export default {
  ERROR_MESSAGE: {
    ADDPLAN: {
      PLANNAME: "Please fill the Plan Name field",
      UPLOAD_FILE: "Please upload the pdf file",
      STATE: "Please select the state",
      JURIDICTION: "Please select the jurisdiction",
      DISCIPLINE: "Please select the disciplines",
      PLANTYPE: "Please select the Plan Type",
      CODEBOOK: "Please select the codebook",
      MANDATORY: "Please fill all the mandatory fields",
      DUPLICATE_DOCUMENT_NAME:
        "Document names cannot be same under upload additional docs section",
    },
    GET: "Error occurred during fetch",
    POST: "Error occurred during submit",
    FILTER_DATA: "Error occurred during filtering data",
    LOGIN_FAIL: "Please try again or contact administrator",
    SET_PREVIOUS_STATE: "Error in setting back previous state",
  },
  invalidSearchString: () => {
    return "Invalid search string";
  },
  errorFetchMoreComments: () => {
    return `Error fetching comments`;
  },
  errorSingleAdditionalDocUpload: (docName) => {
    return `Error occurred during submitting ${docName} details`;
  },
  errorAdditionalDocUpload: (docName) => {
    return `Error occurred during submitting ${docName} document, if error persists please contact .`;
  },
  errorDisciplinesByJobId: (planName) => {
    return `Error occurred during fetching ${planName} discpline details, please contact administrator.`;
  },
  errorVerficationStatus: (planName) => {
    return `Error occurred during submitting ${planName} details, if error persists please contact administrator.`;
  },
  errorVerificationDatesByJobId: (planName) => {
    return `Error occurred during fetching ${planName} verification date details, please contact administrator.`;
  },
  errorVerificationAnnotationByJobId: (planName) => {
    return `Error occurred during fetching ${planName} annotation details, please contact administrator.`;
  },
  errorPlansDownload: () => {
    return `Error occurred during downloading plan`;
  },
  errorFormDataPost: (planName) => {
    return `Error occurred during submitting ${planName} details, if error persists please contact administrator.`;
  },
  postPlanMSG: (planName) => {
    return `Plan ${planName} submitted successfully`;
  },
  postUploadMSG: (text) => {
    return `File ${text} uploaded successfuly`;
  },
  successVerficationStatus: (planName, status) => {
    return `Plan ${planName} ${status}`;
  },
  discardRestoreMessage: (isDiscarded) => {
    let action = isDiscarded ? "discarded" : "restored";
    let actionError = isDiscarded ? "discarding" : "restoring";
    return {
      success: `Annotation ${action} successfully`,
      error: `Error occurred during ${actionError} annotation`,
    };
  },
  rerunPlan: () => {
    return `Plan submitted for re-run successfully`;
  },
  successPreference: () => {
    return `Preference set successfully`;
  },
  ADDANNOTATION: () => {
    return {
      SUCCESS: "Successfully saved annotation",
      ERROR: "Error occured during saving annotation",
    };
  },
  MODIFYANNOTATION: () => {
    return {
      SUCCESS: "Successfully modified annotation",
      ERROR: "Error occured during modifying annotation",
    };
  },
  GETXFDF: "Failed to load annotations",
  GETSTAMP: "Failed to load standard stamps",
  errorVerificationDetailByJobId: () => {
    return `Error occurred during fetching plan details, please contact administrator.`;
  },
  UPDATESTAMPSTATUS: "Failed to update stamp status",
  GETDESIGNCRITERIA: "Failed to load design criteria",
  SAVENEEDSINPUTRESPONSE: () => {
    return {
      SUCCESS: "Successfully saved response",
      ERROR: "Error occured while saving response",
    };
  },
  COMMENTLETTER: () => {
    return {
      SUCCESS: "Draft saved successfully",
      ERROR: "Error occured during saving draft",
    };
  },
  GETENHANCEDSEARCHRESULTS: "Failed to load enhanced search results",
  COPY_SUCCESS: "Successfully copied to clipboard",
  COPY_FAILURE: "Failed to copy",
  INVALID_SEARCH: "Search string cannot contain only special characters",
  UPLOAD_ERROR: "Error while setting the filename",
  ADDITIONAL_DOCS_SUCCESS: "All additional documents uploaded successfully",
  ADDITIONAL_DOCS_START:
    "Uploading addtional documents, it might take some time.",
  FAVOURITEANNOTATION: () => {
    return {
      ADD: "Annotation added to favourite annotation list",
      DELETE: "Annotation deleted from favourite annotation list",
      ERROR: "Error occured while updating favourite annotation list",
      FAILURE: "Annotation can't be make favourite",
      FETCH_ERROR: "Error occured during fetching favourite annotation list"
    };
  },
};
